import { RootState, useSelector } from "src/store";

import { useCurrentSubscription } from "@dashboard/workspaces/api/helpers";

import { selectLicensesByGroupIds } from "../store/selectors";

function useLicenses() {
    const { data: subscription } = useCurrentSubscription({});
    const groupsIds = subscription?.groupIds || [];
    const licenses = useSelector((state: RootState) => selectLicensesByGroupIds(state, groupsIds));
    return licenses;
}

export { useLicenses };
